import StakingPools from './StakingPools.vue'

export default StakingPools
